import { User } from '../common';

export class LoginResponse {
    http_code: string;
    message: string;
    result: {
        internalUser: User;
        token: string;
    };
}
